import { useMemo } from 'react'
import { useActionProps } from 'client/fragments/listerFragment/hooks/useActionProps'
import throttle from 'client/common/throttle'
import { onFilterChange, onFilterClear } from 'client/fragments/listerFragment/store/actions/filterActions'
import { algoliaCallWhenReady, getAlgoliaIndex } from '../../../../common/utils'

const getFilterNameForAlgolia = ({ name, fullName }) => {
  if (fullName) {
    return name
  }
  return `facets.${name}`
}

const onFilterChangeForAlgolia = (filterProps, params) => {
  const collectionNameToFullNameMapping = Object.fromEntries(
    filterProps.collection.map(({ name, fullName }) => [name, fullName])
  )
  const filters = Object.values(filterProps.active).flatMap(valuesRaw => {
    return valuesRaw.flatMap(({ name, value }) => {
      // CASE 1: remove item (unckeched)
      if (!params.item.checked && params.name === name && params.item.value === value) {
        return []
      }
      return { name: getFilterNameForAlgolia({ name, fullName: collectionNameToFullNameMapping[name] }), value }
    })
  })
  // CASE 1: add item (ckeched)
  if (params.item.checked) {
    filters.push({
      name: getFilterNameForAlgolia({ name: params.name, fullName: collectionNameToFullNameMapping[params.name] }),
      value: params.item.value
    })
  }
  if (filters.length) {
    algoliaCallWhenReady('clickedFilters', {
      eventName: 'Filter Clicked',
      index: getAlgoliaIndex(),
      filters: filters.map(({ name, value }) => `${name}:${value}`)
    })
  }
}

export const OPTION_CLICK_DELAY = 300
export function useFilters({ filters: { collection, active }, t }) {
  const handlerCommonProps = useActionProps()
  const { format, lang, categoryCode } = handlerCommonProps
  const preventClick = !categoryCode

  const filterProps = useMemo(
    () => ({ ...handlerCommonProps, collection, active }),
    [handlerCommonProps, collection, active]
  )

  const onChange = params =>
    throttle(() => {
      onFilterChangeForAlgolia(filterProps, params)
      onFilterChange(filterProps)(params)
    }, OPTION_CLICK_DELAY)
  const onClear = onFilterClear(filterProps)
  const buttonActiveText = t('lister.filters.collapse')
  const buttonInactiveText = t('lister.filters.extend')
  const rangeFilterToText = t('lister.filters.range_to')

  return { onChange, onClear, preventClick, format, lang, t, buttonActiveText, buttonInactiveText, rangeFilterToText }
}
